<ng-container *ngIf="devices?.length; else emptyState">
	<div class="device-group" *ngFor="let group of groups; trackBy: trackByFarmId">
		<div class="farm-name">{{ group.farm.name }}</div>
		<div class="device-row" *ngFor="let device of group.devices; trackBy: trackByDeviceId">
			<span class="device-name">
				<ng-container *ngIf="device.name; else numberLabel">{{ device.name }}</ng-container>
				<ng-template #numberLabel>{{
					'sf.shared_component.my_account.devices_section.device_label'
						| translate: { number: deviceNumberLabel(device) }
				}}</ng-template>
			</span>
			<div class="device-meta">
				<sf-device-status-label [status]="device.status"></sf-device-status-label>
				<div class="device-actions">
					<button
						*ngIf="device.status === FarmDeviceStatus.CONNECTED"
						mat-icon-button
						class="action-button"
						type="button"
						[disabled]="isDevicePending(device)"
						[matTooltip]="'sf.shared_component.my_account.devices_section.actions.disconnect' | translate"
						matTooltipPosition="above"
						(click)="onDisconnectClick(device)"
					>
						<mat-spinner
							*ngIf="isDisconnecting(device); else disconnectIcon"
							[diameter]="20"
							color="accent"
						></mat-spinner>
						<ng-template #disconnectIcon><mat-icon>link_off</mat-icon></ng-template>
					</button>
					<button
						*ngIf="device.status === FarmDeviceStatus.DISCONNECTED"
						mat-icon-button
						class="action-button"
						type="button"
						[disabled]="isDevicePending(device)"
						[matTooltip]="'sf.shared_component.my_account.devices_section.actions.generate_new_code' | translate"
						matTooltipPosition="above"
						(click)="onGenerateNewCodeClick(device)"
					>
						<mat-spinner *ngIf="isReissuing(device); else generateIcon" [diameter]="20" color="accent"></mat-spinner>
						<ng-template #generateIcon><mat-icon>autorenew</mat-icon></ng-template>
					</button>
					<button
						*ngIf="device.status === FarmDeviceStatus.PENDING"
						mat-icon-button
						class="action-button"
						type="button"
						[disabled]="isDevicePending(device)"
						[matTooltip]="'sf.shared_component.my_account.devices_section.actions.preview_code' | translate"
						matTooltipPosition="above"
						(click)="onPreviewCodeClick(device)"
					>
						<mat-spinner *ngIf="isPreviewing(device); else previewIcon" [diameter]="20" color="accent"></mat-spinner>
						<ng-template #previewIcon><mat-icon>visibility</mat-icon></ng-template>
					</button>
					<button
						*ngIf="device.status === FarmDeviceStatus.PENDING || device.status === FarmDeviceStatus.DISCONNECTED"
						mat-icon-button
						class="action-button delete"
						type="button"
						[disabled]="isDevicePending(device)"
						[matTooltip]="'sf.shared_component.my_account.devices_section.actions.delete' | translate"
						matTooltipPosition="above"
						(click)="onDeleteClick(device)"
					>
						<mat-spinner *ngIf="isDeleting(device); else deleteIcon" [diameter]="20" color="accent"></mat-spinner>
						<ng-template #deleteIcon><mat-icon>delete</mat-icon></ng-template>
					</button>
				</div>
			</div>
		</div>
	</div>
</ng-container>

<ng-template #emptyState>
	<p class="empty-state">{{ 'sf.shared_component.my_account.devices_section.empty' | translate }}</p>
</ng-template>
